import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Bounce, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import config from "../config";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

const LoginPage = () => {
  const { setClientData } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "onBlur", // This triggers validation when inputs lose focus
  });

  const [loading, setLoading] = useState(false); // Loading state for form submission
  const [showPass, setShowPass] = useState(true); // Loading state for form submission
  const handleDefulePass = (event) => {
    console.log(event.target.checked);

    setShowPass(!event.target.checked);

    setValue("password", event.target.checked ? "defaultPassword123" : "");
  };
  const handleFormSubmit = async (data) => {
    setLoading(true); // Start loading indicator
    try {
      // Call the API to create the client
      const response = await fetch(`${config.apiUrl}/clients/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Set the content type to JSON
        },
        body: JSON.stringify({
          username: data.username,
          password: data.password,
        }),
      });
      // Check if the response status is OK (status code 200)
      if (response.ok) {
        const { isAuthenticated, client } = await response.json();
        if (isAuthenticated === null) {
          setClientData(client);
          navigate("/update", { state: { profile: client } });
        }
        if (isAuthenticated) {
          setClientData(client);
          toast.success(t("loginsuccess"), {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
          navigate("/");
          reset(); // Reset form fields after success
        } else {
          toast.error(t("loginfail"), {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
        }
      } else {
        toast.error(t("loginfail"), {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      toast.error(`Error: ${error.message || "Something went wrong"}`, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false); // Stop loading indicator
    }
  };
  return (
    <div     dir={i18next.language === "ar" ? "rtl" : "ltr"} className="min-h-screen  flex flex-col items-center justify-start p-0 -mt-5">
      <div className="relative w-[75%] sm:w-[90%] max-[450px]:w-[95%] flex justify-end flex-col items-center  bg-white rounded-t-none rounded-b-3xl  shadow-lg px-4  sm:pt-28  space-y-0">
        <div className=" justify-items-center space-y-3 font-[roboto]   mt-2 text-center ">
        <div> 
             <svg
            className="h-14 w-14"
            viewBox="0 0 158 146"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_12_399)">
              <path
                d="M12.5905 145.999C9.99855 145.999 7.75113 145.401 5.86461 144.214C3.97809 143.027 2.52629 141.423 1.51742 139.409C0.50854 137.395 0 135.16 0 132.696C0 130.24 0.50854 127.997 1.51742 125.983C2.52629 123.969 3.97809 122.364 5.86461 121.177C7.75113 119.99 9.99034 119.393 12.5905 119.393C14.559 119.393 16.3307 119.736 17.8973 120.432C19.4721 121.128 20.8091 122.078 21.9082 123.281C23.0073 124.485 23.8357 125.885 24.3853 127.481H21.2766C20.6205 125.885 19.587 124.616 18.168 123.674C16.749 122.733 14.9691 122.258 12.8201 122.258C10.7203 122.258 8.93225 122.725 7.45585 123.65C5.97124 124.583 4.85573 125.827 4.09292 127.399C3.33011 128.971 2.95281 130.739 2.95281 132.696C2.95281 134.636 3.33011 136.396 4.09292 137.976C4.85573 139.556 5.97124 140.817 7.45585 141.742C8.94046 142.675 10.7285 143.134 12.8201 143.134C14.9691 143.134 16.749 142.659 18.168 141.717C19.587 140.776 20.6205 139.507 21.2766 137.911H24.3853C23.8357 139.483 23.0073 140.874 21.9082 142.094C20.8091 143.314 19.4721 144.264 17.8973 144.959C16.3307 145.655 14.559 145.999 12.5905 145.999Z"
                fill="#66B8D9"
              />
              <path
                d="M30.7676 145.687V119.703H33.7204V142.863H47.9185V145.687H30.7676Z"
                fill="#66B8D9"
              />
              <path
                d="M53.6914 145.687V119.703H72.8437V122.528H56.6442V131.238H71.113V134.103H56.6442V142.855H72.8437V145.679H53.6914V145.687Z"
                fill="#66B8D9"
              />
              <path
                d="M76.502 145.687L87.5504 119.703H91.2496L102.298 145.687H99.0335L95.8511 138.148H82.9489L79.7665 145.687H76.502ZM84.089 135.438H94.711L89.4041 122.757L84.089 135.438Z"
                fill="#66B8D9"
              />
              <path
                d="M107.572 145.687V119.703H110.993L127.077 141.57V119.703H130.03V145.687H126.61L110.525 123.747V145.687H107.572Z"
                fill="#66B8D9"
              />
              <path
                d="M147.691 145.999C145.123 145.999 143.04 145.655 141.44 144.959C139.841 144.263 138.644 143.305 137.84 142.077C137.036 140.849 136.577 139.458 136.445 137.918H139.513C139.595 139.171 140.013 140.186 140.768 140.964C141.531 141.733 142.531 142.307 143.778 142.675C145.025 143.043 146.395 143.223 147.887 143.223C150.086 143.223 151.833 142.839 153.12 142.069C154.408 141.3 155.048 140.153 155.048 138.631C155.048 137.714 154.728 136.977 154.088 136.412C153.449 135.847 152.596 135.389 151.529 135.02C150.471 134.652 149.306 134.325 148.051 134.022C146.797 133.719 145.525 133.399 144.254 133.064C142.982 132.728 141.818 132.294 140.751 131.77C139.693 131.246 138.84 130.575 138.192 129.748C137.553 128.921 137.233 127.874 137.233 126.588C137.233 124.468 138.053 122.741 139.693 121.406C141.334 120.072 143.778 119.4 147.026 119.4C149.331 119.4 151.234 119.744 152.727 120.44C154.22 121.136 155.343 122.045 156.09 123.166C156.836 124.288 157.246 125.508 157.328 126.817H154.302C154.146 125.508 153.49 124.402 152.333 123.502C151.177 122.601 149.413 122.151 147.026 122.151C145.558 122.151 144.369 122.298 143.45 122.585C142.531 122.872 141.834 123.248 141.342 123.707C140.858 124.165 140.53 124.64 140.358 125.139C140.186 125.639 140.104 126.105 140.104 126.555C140.104 127.415 140.423 128.119 141.063 128.659C141.703 129.2 142.556 129.642 143.622 129.994C144.68 130.346 145.853 130.665 147.141 130.952C148.429 131.238 149.7 131.558 150.98 131.91C152.251 132.262 153.416 132.712 154.482 133.244C155.54 133.784 156.393 134.464 157.041 135.307C157.681 136.142 158.001 137.214 158.001 138.524C158.001 140.931 157.082 142.781 155.245 144.075C153.408 145.352 150.889 145.999 147.691 145.999Z"
                fill="#66B8D9"
              />
              <path
                d="M128.71 23.3973L124.461 7.0896C123.378 2.91443 119.605 0 115.283 0H46.3265C42.0039 0 38.2308 2.91443 37.1481 7.08142L32.8748 23.4956C32.4893 24.9855 33.3833 26.5001 34.8679 26.8848C36.3607 27.2696 37.8782 26.3773 38.2637 24.8955L42.537 8.48133C42.537 8.47314 42.5452 8.46495 42.5452 8.44858C42.9389 6.97499 44.5548 6.18908 46.0066 6.67209C47.1057 7.0323 48.336 7.44163 48.336 7.44163C51.945 8.50589 55.554 9.29999 59.163 9.93854C66.381 11.1829 73.5908 11.756 80.8087 11.7478C88.0267 11.7396 95.2365 11.1583 102.454 9.91398C106.063 9.26724 109.672 8.47314 113.281 7.41707C113.281 7.41707 114.512 7.00774 115.603 6.64753C117.046 6.1727 118.654 6.95862 119.056 8.42402C119.064 8.44039 119.064 8.45677 119.072 8.47314L123.346 24.8791C123.674 26.1317 124.806 26.9585 126.044 26.9585C126.413 26.9585 126.791 26.8848 127.16 26.7293C128.431 26.1972 129.063 24.7399 128.71 23.3973Z"
                fill="#FF8C00"
              />
              <path
                d="M145.261 37.5756L144.343 34.5138C143.547 31.8777 141.48 29.8065 138.831 29.0124L135.763 28.0955C134.631 27.7598 134.631 26.1552 135.763 25.8196L138.831 24.9027C141.472 24.1086 143.547 22.0456 144.343 19.4013L145.261 16.3395C145.597 15.2097 147.205 15.2097 147.541 16.3395L148.46 19.4013C149.256 22.0374 151.323 24.1086 153.972 24.9027L157.04 25.8196C158.172 26.1552 158.172 27.7598 157.04 28.0955L153.972 29.0124C151.331 29.8065 149.256 31.8695 148.46 34.5138L147.541 37.5756C147.205 38.7053 145.597 38.7053 145.261 37.5756Z"
                fill="#66B8D9"
              />
              <path
                d="M66.2897 70.7578H42.2243C40.6823 70.7578 39.4355 72.0022 39.4355 73.5413C39.4355 75.0803 40.6823 76.3247 42.2243 76.3247H66.2897C67.8317 76.3247 69.0785 75.0803 69.0785 73.5413C69.0785 72.0022 67.8317 70.7578 66.2897 70.7578Z"
                fill="#FF8C00"
              />
              <path
                d="M117.013 32.5911C113.027 32.5911 103.43 32.0836 93.2021 37.9452C85.8446 42.1613 79.1106 48.1948 75.1079 56.1768C74.1072 58.1743 73.287 60.2619 72.5816 62.3986C71.8926 64.5435 71.4333 66.7621 71.0724 68.997C70.9248 70.1186 70.7689 71.2401 70.7033 72.3699L70.6377 73.2213L70.6213 73.4341L70.6131 73.6715L70.5967 74.0481L70.5146 75.1615C70.3834 76.6187 70.1783 78.0596 69.8256 79.4595C69.1531 82.2675 68.1688 84.9773 66.7416 87.4578C66.028 88.694 65.298 89.922 64.4286 91.0517C63.5673 92.1897 62.6241 93.2621 61.6152 94.2691C60.6063 95.276 59.54 96.2257 58.4163 97.1016C57.2844 97.9694 56.0705 98.7308 54.8319 99.4348C52.3631 100.876 49.6563 101.899 46.8511 102.578C45.4486 102.947 44.005 103.16 42.5532 103.307L41.4459 103.397L40.2319 103.454C39.4855 103.512 38.7473 103.495 38.0009 103.504C36.5163 103.463 35.0235 103.34 33.5389 103.094C32.0543 102.865 30.5615 102.554 29.1015 102.104C23.2369 100.376 17.6347 96.9543 13.0907 92.0832C12.5739 91.5347 11.9834 90.7898 11.3764 89.9793C7.22606 84.396 5.10988 77.5111 5.67583 70.5852C5.70864 70.2086 5.74145 69.8402 5.78246 69.4636C7.83303 51.5268 23.4009 38.158 41.4869 38.158H59.0479V44.2161C59.0479 46.9668 61.2871 49.2018 64.0431 49.2018C66.4627 49.2018 68.4723 47.4908 68.9398 45.2149C69.0136 44.9611 69.0628 44.6991 69.0628 44.4208V32.6075C69.0628 32.5993 69.0546 32.5911 69.0464 32.5911H41.5279C18.9471 32.5911 0.213134 50.5853 -0.000124912 73.1149C-0.213383 95.8491 18.2581 114.408 40.9865 114.408H41.5033C52.2892 114.408 62.4108 110.192 70.0061 102.546C77.5932 94.8994 81.7189 84.7562 81.6205 73.9908L81.6123 73.4996C81.6123 54.0155 97.5 38.158 117.021 38.158C129.489 38.158 140.455 44.6255 146.771 54.3675C148.165 56.7498 157.303 73.6716 144.597 88.7185C144.089 89.2589 143.58 89.7828 143.08 90.2904C138.798 94.5802 134.09 97.7647 129.021 100.073C127.758 100.663 126.454 101.17 125.133 101.621C124.477 101.883 123.796 102.071 123.116 102.284C122.861 102.366 122.615 102.431 122.353 102.488C122.099 102.546 121.844 102.611 121.59 102.693L121.073 102.824C119.695 103.209 118.268 103.397 116.816 103.667L115.717 103.815C115.365 103.864 115.012 103.872 114.659 103.921C114.29 103.978 113.921 104.019 113.552 104.044C113.158 104.068 112.756 104.126 112.363 104.126C111.985 104.134 111.608 104.15 111.222 104.183L110.066 104.216C109.672 104.24 109.295 104.216 108.901 104.208C108.507 104.199 108.106 104.216 107.712 104.191C106.121 104.15 104.488 104.052 102.823 103.823C99.9771 103.43 95.0148 101.138 93.6368 100.024C92.5623 99.1565 91.0285 99.0173 89.9622 99.8933C88.6088 101.015 88.6088 103.021 89.8802 104.134C97.377 110.749 107.015 114.392 117.03 114.392C139.627 114.392 158.016 96.0374 158.016 73.4833C158.016 50.9291 139.619 32.5911 117.013 32.5911Z"
                fill="#FF8C00"
              />
            </g>
            <defs>
              <clipPath id="clip0_12_399">
                <rect width="158" height="146" fill="white" />
              </clipPath>
            </defs>
          </svg>
          </div>
          <h1 className="text-3xl  font-bold text-orange-400">
            {t("welcome")}
          </h1>
        </div>

        <div className="space-y-6 w-[85%] max-[450px]:w-[95%]  lg:w-[50%] py-10 ">
          <h2 className="text-xl font-bold text-[#0a2942]">{t("login")} </h2>
          <form id="login-form" onSubmit={handleSubmit(handleFormSubmit)}>
            <div className="space-y-4">
              <div>
                <input
                  type="text"
                  {...register("username", { required: t("usernamereq") })}
                  placeholder={t("uem")}
                  className={`w-full px-4 py-3 rounded-full bg-[#f0f9ff] border-none focus:ring-2 focus:ring-[#47b5ff] ${
                    errors.password ? "border-red-500" : ""
                  }`}
                />
                {errors.username && (
                  <p className="text-xs text-red-500">
                    {errors.username.message}
                  </p>
                )}
              </div>

              <div>
                <input
                  type="password"
                  {...register("password", {
                    required: t("password"),
                  })}
                  placeholder={t("password")}
                  hidden={!showPass}
                  className={`w-full px-4 py-3 rounded-full bg-[#f0f9ff] border-none focus:ring-2 focus:ring-[#47b5ff] ${
                    errors.password ? "border-red-500" : ""
                  }`}
                />
                {errors.password && (
                  <p className="text-xs text-red-500">
                    {errors.password.message}
                  </p>
                )}
              </div>
              <div className="text-right">
                <div className="space-y-2 space-x-2">
                  <label
                    htmlFor="havePass"
                    className="text-sm font-medium text-[#47b5ff]"
                  >
                    {t("nopassword")}{" "}
                  </label>
                  <input
                    id="havePass"
                    type="checkbox"
                    onChange={handleDefulePass}
                    className={`w-4 h-4 rounded-md bg-[#f0f9ff] border-2 border-[#47b5ff] focus:ring-2 focus:ring-[#47b5ff]`}
                  />
                </div>
              </div>
              <div className="text-right">
                <a
                  href="/forget-password"
                  className="text-[#47b5ff] hover:underline"
                >
                  {t("forgotpassword")}
                </a>
              </div>
            </div>
          </form>
        </div>
        <div className="absolute w-[85%] max-[450px]:w-[80%]   lg:w-[50%] bottom-0 translate-y-1/2 ">
          <button
            disabled={isSubmitting || loading}
            onClick={() =>
              document
                .getElementById("login-form")
                .dispatchEvent(
                  new Event("submit", { cancelable: true, bubbles: true })
                )
            }
            className="w-full bg-[#ff8000] hover:bg-[#ff9933] text-white font-bold py-4 max-[450px]:py-2  rounded-full transition duration-200"
          >
            {t("login")}
          </button>
        </div>
      </div>
      <div className="text-center mt-9">
        <p className="text-[#0a2942]">
          {t("noaccount")}{" "}
          <a href="/register" className="font-bold hover:underline">
            {t("signUp")}.
          </a>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
